import React from "react";
import { Container, Tabs, Tab } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import OverviewTab from "../../components/timeDistribution/OverviewTab/OverviewTab";
import PlanningTab from "../../components/timeDistribution/PlanningTab/PlanningTab";
import DirectoryTab from "../../components/timeDistribution/DirectoryTab/DirectoryTab";

const TimeDistribution = () => {
  const { t } = useTranslation();

  return (
    <Container fluid className="px-4 py-4" style={{ backgroundColor: "var(--bg-main, #f8f9fa)", minHeight: "100vh" }}>
      
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="fw-bold txt-main mb-1" style={{ fontSize: "1.5rem" }}>
            {t('pages.timeDistribution.title')}
          </h2>
          <p className="txt-subtle mb-0" style={{ fontSize: "0.85rem" }}>
            {t('pages.timeDistribution.subtitle')}
          </p>
        </div>
      </div>

      <div className="mt-4">
        <Tabs
          defaultActiveKey="overview"
          id="time-distribution-tabs"
          className="mb-4 custom-tabs"
          mountOnEnter
          unmountOnExit
        >
          
          <Tab eventKey="overview" title={t('pages.timeDistribution.tabs.overview')}>
            <OverviewTab />
          </Tab>
          
          <Tab eventKey="planning" title={t('pages.timeDistribution.tabs.planning')}>
            <PlanningTab />
          </Tab>
          
          <Tab eventKey="directory" title={t('pages.timeDistribution.tabs.directory')}>
            <DirectoryTab />
          </Tab>
          
        </Tabs>
      </div>
      
    </Container>
  );
};

export default TimeDistribution;
